"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ATTRIBUTE_VALUE_BY_NAME = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_ATTRIBUTE_VALUE_BY_NAME = (0, gql_1.gql)(`
  query GetAttributeValueByName(
    $productTreeNodeId: ID!,
    $attributeName: String!,
    $valueName: String,
    $skipValues: Boolean!
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      labelValidation(filter: { some: { label: { equals: $attributeName } } }, first: 1) {
        edges {
          node {
            label
            description
            values(filter: { some: { value: { equals: $valueName } } }, first: 1) @skip (if: $skipValues) {
              edges {
                node {
                  value
                  description
                }
              }
            }
          }
        }
      }
    }
  }
`);
